/**
 * This function is an explicit wrapper around `new Date()`.
 *
 * Its name makes it clear that you are retrieving the device's local time.
 *
 * @see https://gitlab.veevadev.com/myveeva-clinicaltrials/web/-/blob/develop/packages/eslint/docs/no-current-datetime.md
 */
// oxlint-disable-next-line web-rules/no-current-datetime
export const getDeviceDate = (): Date => new Date()
